import * as Yup from 'yup';
// project import
import {
    FormConfigBuilder,
    GLOBAL_FIELD_PROPS,
} from 'components/form-builder/FormConfigBuilder';

import { DataEntry } from 'models/nostradamus/administration/DataEntry';
import { FormFieldCustomComponentTypes } from 'constants/FormFieldCustomComponentTypes';
import { EventTypeConfig } from 'constants/const/EventTypeConfig';

const schema = Yup.array(Yup.string());

// eslint-disable-next-line no-unused-vars
const formConfig = (methods = null, watch = null, mode = null) => {
    return new FormConfigBuilder(
        [
            {
                componentType: FormFieldCustomComponentTypes.Select,
                attribute: 'type',
                title: 'Event type',
                validations: [['required', true]],
                col: {
                    sm: 6,
                },
                optionConfig: {
                    key: 'value',
                    value: 'value',
                    label: 'label',
                },
                options: EventTypeConfig,
                list: {
                    headerName: 'Event type',
                    sorting: true,
                    filtering: true,
                    // minWidth: 300
                },
            },
            {
                componentType:
                    FormFieldCustomComponentTypes.CustomDateTimePicker,
                attribute: 'started_at',
                title: 'Start',
                validations: [['required', true]],
                // list: {
                //     headerName: "Start",
                // },
            },
            {
                componentType:
                    FormFieldCustomComponentTypes.CustomDateTimePicker,
                attribute: 'finished_at',
                title: 'End',
                // validations: [["required", true]],
                // list: {
                //     headerName: "End",
                // },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'unit',
                title: 'Company/Battalion',
                // validations: [["required", true]],
                list: {
                    headerName: 'Company/Battalion',
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'local_unit',
                title: 'Position',
                // validations: [["required", true]],
                list: {
                    headerName: 'Position',
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'weapon_type',
                title: 'Weapon type',
                list: {
                    headerName: 'Weapon type',
                },
            },

            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'caliber',
                title: 'Caliber',
                // list: {
                //     headerName: "Caliber",
                // },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'mgrs_coordinates',
                title: 'MGRS coordinates',
                // list: {
                //     headerName: "MGRS coordinates",
                // },
            },
            // {
            //     componentType: FormFieldCustomComponentTypes.TextField,
            //     attribute: "coordinates",
            //     title: "Coordinates",
            //     // list: {
            //     //     headerName: "Coordinates",
            //     // },
            // },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'direction',
                title: 'Direction',
                // list: {
                //     headerName: "Direction",
                // },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'azimuth',
                title: 'Azimuth',
                // list: {
                //     headerName: "Azimuth",
                // },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'target_type',
                title: 'Target type',
                list: {
                    headerName: 'Target type',
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'target_quantity',
                title: 'Quantity',
                list: {
                    headerName: 'Quantity',
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'result',
                title: 'Result',
                list: {
                    headerName: 'Result',
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.Switch,
                attribute: 'status',
                title: 'Verified',
                // validations: [["required", true]],
                list: {
                    headerName: 'Verified',
                },
            },
        ],
        DataEntry,
    );
};

const config = [{ config: formConfig }];

export default config;
